import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'
import Scrollspy from 'vue2-scrollspy';
import VueSweetalert2 from 'vue-sweetalert2';
import "../src/design/app.scss";
import store from '@/state/store'
import App from './App.vue'
import Multiselect from 'vue-multiselect'
import tinymce from 'vue-tinymce-editor'
import VueBootstrapToasts from "vue-bootstrap-toasts";
import excel from 'vue-excel-export'
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import VueQRCodeComponent from 'vue-qrcode-component';
import VueSpeedMeter from "vue-speed-meter";

import VueQuillEditor from 'vue-quill-editor';
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.component('qr-code', VueQRCodeComponent)
Vue.component('tinymce', tinymce)
Vue.component("vue-speed-meter", VueSpeedMeter);
Vue.use(VueQuillEditor)
Vue.use(VueRouter)
Vue.use(vco)
Vue.use(excel)
Vue.use(Scrollspy);
const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
Vue.config.productionTip = false
Vue.use(VueBootstrapToasts);
Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.component('multiselect', Multiselect)
Vue.use(require('vue-chartist'))
Vue.use(VueSweetalert2);
Vue.component('apexchart', VueApexCharts)
Vue.component("v-select", vSelect);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')